module.exports = __webpack_public_path__ + "img/svg/background-footer-menu-mobile.141be9840e5d070777af9c92f832376d.svg";